























































import { Component, Vue } from "vue-property-decorator";

import { passwordApi } from "../../plugins/auth-plugin/services/password.api";
import appSnackbarService from "../../services/appSnackbar.service";
import { PASSWORD_POLICY_REGEX } from "../../helpers/passwordPolicy";

@Component({})
export default class ChangeUserPassword extends Vue {
  currentPassword = "";
  password1 = "";
  password2 = "";
  userName = "";
  errorMessage = "";
  valid = false;
  loading = false;

  show1 = false;
  show2 = false;

  passwordRule(v: string) {
    if (!PASSWORD_POLICY_REGEX.test(v)) {
      return this.$t("CHANGE_PASSWORD_RULE");
    }
    return true;
  }

  changePassword() {
    (this.$refs.form as any).validate();
    if (this.valid) {
      this.loading = true;
      passwordApi
        .resetUserPassword(this.currentPassword, this.password2)
        .then(() => {
          this.$router.replace("/login");
          appSnackbarService.success(
            this.$t("CHANGE_PASSWORD_SUCCESS") as string
          );
        })
        .catch(error => {
          this.errorMessage = this.$t("CHANGE_PASSWORD_ERROR") as string;
          this.loading = false;
        });
    }
  }
}
